
































































































































































import _ from "lodash";

import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { Customer } from "@/models";

@Component
export default class CustomerDetail extends Vue {
  @Prop({ default: false }) public showsidebar: boolean;

  @Getter("customers/hasUnsavedChanges") public hasUnsavedChanges: boolean;

  @Getter("customers/current") public customer: Customer;

  @Getter("customers/list") public customerlist: Customer[];

  @Mutation("customers/setCurrent")
  public setCurrent: (customer: Customer) => void;

  @Action("customers/setCustomerDeep")
  public setCustomerDeep: (payload: {
    path: string;
    data: any;
  }) => Promise<any>;

  @Action("customers/addCustomer")
  public addCustomer: (customer: Customer) => Promise<any>;

  @Action("customers/updateCustomer")
  public updateCustomer: (customer: Customer) => Promise<any>;

  public mounted() {
    if (this.isNewCustomer()) {
      this.setCurrent(new Customer());
    }
  }

  get customerNameOptions() {
    let list: string[] = [];
    if (this.customerlist)
      list = this.customerlist.map((c: Customer) => c.companyName);
    return list;
  }

  public addNewCustomer(val: string): void {
    this.name = val;
  }

  public clearCustomerName(): void {
    this.name = "";
  }

  get name() {
    return this.customer.companyName;
  }
  set name(data) {
    this.setCustomerDeep({ path: "companyName", data });
  }

  get branch() {
    return this.customer.branchName;
  }
  set branch(data) {
    this.setCustomerDeep({ path: "branchName", data });
  }

  get contactname() {
    return this.customer.contactName;
  }
  set contactname(data) {
    this.setCustomerDeep({ path: "contactName", data });
  }

  get addressLine1() {
    return this.customer.address.line1;
  }
  set addressLine1(data) {
    this.setCustomerDeep({ path: "address.line1", data });
  }

  get addressLine2() {
    return this.customer.address.line2;
  }
  set addressLine2(data) {
    this.setCustomerDeep({ path: "address.line2", data });
  }

  get addressTown() {
    return this.customer.address.town;
  }
  set addressTown(data) {
    this.setCustomerDeep({ path: "address.town", data });
  }

  get addressCounty() {
    return this.customer.address.county;
  }
  set addressCounty(data) {
    this.setCustomerDeep({ path: "address.county", data });
  }

  get addressPostcode() {
    return this.customer.address.postcode;
  }
  set addressPostcode(data) {
    this.setCustomerDeep({ path: "address.postcode", data });
  }

  get phone() {
    return this.customer.address.phone;
  }
  set phone(data) {
    this.setCustomerDeep({ path: "address.phone", data });
  }

  get email() {
    return this.customer.address.email;
  }
  set email(data) {
    this.setCustomerDeep({ path: "address.email", data });
  }

  public canAdd() {
    let result = true;
    if (!this.addressLine1 || !this.addressTown || !this.addressPostcode)
      result = false;
    return result;
  }

  public isNewCustomer() {
    return this.$router.currentRoute.params.id == "new";
  }

  public isSaving: boolean = false;
  public saveAll() {
    if (this.isNewCustomer()) {
      this.isSaving = true;
      this.addCustomer(this.customer).then(() => {
        this.isSaving = false;
        this.$toasted.success("Added");
        this.$router.push("/customers");
      });
    } else {
      this.isSaving = true;
      this.updateCustomer(this.customer).then(() => {
        this.isSaving = false;
        this.$toasted.success("Saved");
        this.$router.push("/customers");
      });
    }
  }

  public canSave() {
    return this.hasUnsavedChanges && this.name;
  }

  public cancel() {
    this.setCurrent(new Customer());
    this.$router.push("/customers");
  }
}
